import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { useContent } from 'features/unifiedFlow/contentPage/hooks'
import { integrationWorkflowCardClicked } from 'features/unifiedFlow/store/unifiedFlowSlice'

import MainContent from '../../components/MainContent'

import CenterSection from './centerSection'
import LeftSection from './leftSection'
import RightSection from './rightSection'

const Integrations = () => {
  const dispatch = useAppDispatch()

  const { content } = useContent()

  const integrationSelectedElementId = useAppSelector(
    (state) => state.unifiedFlow.integrationSelectedElementId
  )

  useEffect(() => {
    if (!integrationSelectedElementId) {
      dispatch(integrationWorkflowCardClicked({ elementId: 1 }))
    }
  }, [content?.elements, dispatch, integrationSelectedElementId])

  return (
    <MainContent className="flex-wrap pb-6" id="main-content-page">
      <LeftSection />
      <CenterSection />
      <RightSection />
    </MainContent>
  )
}

export default Integrations
